import { config } from './config';

export function getSignalingUrl(peerId, roomId, projectId,
	screenPage, _uid, record, mDeviceId, mDeviceType, displayName,
	breakoutRooms=false, breakoutRoomId=null, isHorP, peerType, pairId, mode, presenceUserId
)
{
	const hostname = config.serverHostname || window.location.hostname;
	const port =
		import.meta.env.MODE !== 'production' ?
			config.developmentPort
			:
			config.productionPort;

	let _tp=false;

	if (screenPage || mode)
	{
		_tp = true;
	}

	const url = `wss://${hostname}:${port}/?peerId=${peerId}&roomId=${roomId}&projectId=${projectId}&tp=${_tp}&_uid=${_uid}&record=${record}&mDeviceId=${mDeviceId}&mDeviceType=${mDeviceType}&displayName=${displayName}&breakoutRooms=${breakoutRooms}&breakoutRoomId=${breakoutRoomId}&isHorP=${isHorP}&peerType=${peerType}&pairId=${pairId}&mode=${mode}&screen=${screenPage}&presenceUserId=${presenceUserId}`;
	// const url = `https://192.168.2.100:3463/?peerId=${peerId}&roomId=${roomId}&projectId=${projectId}&tp=${_tp}&_uid=${_uid}&record=${record}&mDeviceId=${mDeviceId}&mDeviceType=${mDeviceType}&displayName=${displayName}&breakoutRooms=${breakoutRooms}&breakoutRoomId=${breakoutRoomId}&isHorP=${isHorP}&peerType=${peerType}&pairId=${pairId}&mode=${mode}&screen=${screenPage}&presenceUserId=${presenceUserId}`;

	return url;
}
